import { render, staticRenderFns } from "./ProcessedIssues.vue?vue&type=template&id=80a08a16&scoped=true"
import script from "./ProcessedIssues.vue?vue&type=script&lang=js"
export * from "./ProcessedIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a08a16",
  null
  
)

export default component.exports